var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 36,
    viewBox: "0 0 46 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 34,
    rx: 3,
    fill: "white",
    stroke: "#C2C8CE",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27069 21.1629C6.09679 21.3483 6 21.593 6 21.8471V28C6 28.5523 6.44772 29 7 29H39C39.5523 29 40 28.5523 40 28V19.3073C40 19.0813 39.9234 18.8619 39.7827 18.6849L32.3815 9.3776C32.2078 9.15914 31.9507 9.02323 31.6723 9.00271C31.394 8.98219 31.1197 9.07893 30.9158 9.26954L22.9192 16.7461L16.1881 11.8687C15.7804 11.5732 15.2166 11.627 14.872 11.9942L6.27069 21.1629Z",
    stroke: "#C2C8CE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.5C11 9.88071 9.88071 11 8.5 11C7.11929 11 6 9.88071 6 8.5C6 7.11929 7.11929 6 8.5 6C9.88071 6 11 7.11929 11 8.5Z",
    stroke: "#C2C8CE",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAsset);
export default __webpack_public_path__ + "static/media/no_asset.93a3c4a5c686c1897f7fc424906c9aef.svg";
export { ForwardRef as ReactComponent };